import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IStockItemSupplierFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		stockItemId?: any;
		supplierId?: any;
		code?: any;
		price?: any;
}

export class StockItemSupplierFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public stockItemId: IEntityModelField = { name: "stockItemId", displayName: "Stock Item Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public supplierId: IEntityModelField = { name: "supplierId", displayName: "Supplier Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public code: IEntityModelField = { name: "code", displayName: "Code", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public price: IEntityModelField = { name: "price", displayName: "Price", fieldType: FieldType.Float, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.stockItemId);
		this.push(this.supplierId);
		this.push(this.code);
		this.push(this.price);
	}
}

export class StockItemSupplierDTO implements IEntityModel {
	protected stockItemSupplierName: string = "StockItemSupplierModel";
	protected stockItemSupplierKeyField: string = "id";
	protected stockItemSupplierDisplayName: string = "Stock Item Supplier|Stock Item Suppliers";
	protected stockItemSupplierFields = new StockItemSupplierFields();
	public get name(): string { return this.stockItemSupplierName };
	public get keyField(): string { return this.stockItemSupplierKeyField };
	public get displayName(): string { return this.stockItemSupplierDisplayName };
	public get fields(): StockItemSupplierFields { return this.stockItemSupplierFields };

	constructor() {};
}
